<template>
  <div class="main">
    <div class="left" v-if="topindex!=3">

      <p :class="item.isChecked?'check':''" v-for='(item,index) in groupList' :key="item.id"
        @click='chooseGroup(index)'>{{item.name}}<span class='wdxx' v-if="item.wdxx!=0">{{item.wdxx}}</span></p>
    </div>
    <div class="infobox" :style="{'width':normelWidth}">
      <div class=" middle" :style="{'width':(bruserinfo.realName!=''?'80%':'100%')}">
        <a-layout style="height:100%">
          <!-- <a-layout-header class="layout-header">
          <div class="header">
            <span class="setting">
              <a-dropdown>
                <span class="ant-dropdown-link" href="#">
                  <a-icon type="setting" />
                  <span class="username">{{userName}}</span>
                </span>
                <a-menu slot="overlay">
                  <a-menu-item @click="recEmedia">
                    <a href="javascript:;">音视频录制</a>
                  </a-menu-item>
                  <a-menu-item @click="GetFirendBlack">
                    <a href="javascript:;">好友黑名单</a>
                  </a-menu-item>
                  <a-menu-item @click="toLogout">
                    <a href="javascript:;">退出</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>

            <span class="setting">
              <a-dropdown>
                <span class="ant-dropdown-link" href="#">
                  <a-icon type="plus-circle" />
                </span>
                <a-menu slot="overlay">
                  <a-menu-item @click="ulClick('1')">
                    <a href="javascript:;">添加好友</a>
                  </a-menu-item>
                  <a-menu-item @click="ulClick('2')">
                    <a href="javascript:;">申请入群</a>
                  </a-menu-item>
                  <a-menu-item @click="ulClick('3')">
                    <a href="javascript:;">创建群组</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </div>
          <a-menu v-model="current" mode="horizontal" :defaultSelectedKeys="['contact']"
            :style="{ lineHeight: '50px', background: '#434648', color: '#fff', textAlign: 'left'}"
            @click="contactTypeChange">
            <a-menu-item key="contact">
              <a-icon type="user" class="navMenu-icon" />
              <span class="navMenu-text">好友</span>

              <div class="tip-style" v-if="getUnread('contact').contact">&nbsp;</div>
            </a-menu-item>
            <a-menu-item key="group">
              <a-icon type="team" class="navMenu-icon" />
              <span class="navMenu-text">群组</span>
              <div class="tip-style" v-if="getUnread('group').group">&nbsp;</div>
            </a-menu-item>
            <a-menu-item key="chatroom">
              <a-icon type="usergroup-add" class="navMenu-icon" />
              <span class="navMenu-text">聊天室</span>
            </a-menu-item>
          </a-menu>
        </a-layout-header> -->
          <a-layout>
            <a-layout-sider style="background: #fff" :width="broken ? '100%' : 250" breakpoint="lg" collapsedWidth="0"
              :trigger="null" v-model="collapsed" @collapse="onCollapse" @breakpoint="onBreakpoint">
              <MessageBox :type="activeKey" :select="select" ref="messageBox" />
              <!-- <MessageBox v-if="activeKey == 'chatroom'"  type="chatroom" />
        <MessageBox v-if="activeKey == 'group'" type="group" />-->
            </a-layout-sider>

            <a-layout-content style="overflow: visible">
              <Message :type="activeKey" :broken="broken" :hideUserList.sync="hideUserList" :showUserList="showUserList"
                ref="messageList" :bruserinfo="bruserinfo" @fatherMethod="fatherMethod" />

              <AddFriend ref="addFriendMethods" />
              <GetFriendRequest />
              <FirendBlack ref="firendModel" />
              <AddGroupUser ref="addGroupModel" />
              <CreateGroup ref="createGroupModel" />
              <VidoeSetting ref="videoSetting" />
              <GroupRequest />
              <GroupInvite />
            </a-layout-content>
          </a-layout>
        </a-layout>
      </div>
      <div class="right" v-if='bruserinfo.realName!=""'>
        <div class='infotop'>
          <img class="headicon" :src="bruserinfo.headPicture" alt="">
          <p class="nameinfo">{{bruserinfo.realName}}</p>
          <p class="nameinfo">
            <span v-if='bruserinfo.sex==0'>未知</span>
            <span v-if='bruserinfo.sex==1'>男</span>
            <span v-if='bruserinfo.sex==2'>女</span> &nbsp;&nbsp;&nbsp;{{bruserinfo.age}}岁</p>
          <el-button class="right_btn" round @click='danganvisable=true'>会员档案</el-button>
        </div>
        <div class="myplan">
          <p class='plantitle'>我提交的方案</p>
          <div class="planbox" v-if='myplan.length>0'>
            <div class='planLists' v-for='item in myplan'>
              <p>标题: <span>{{item.title}}</span> </p>
              <p>总结:<span>{{item.conclusion}}</span></p>
              <p>方案:<span>{{item.plan}}</span></p>
              <div class='planLists'>
                <a class='delete' @click='delPlan(item.id)'>删除</a>
                <a class='edit' @click='handelEdit(item)'>编辑</a>
              </div>
            </div>


          </div>
          <div class="planbox" v-else>
            <img src="../../assets/zwsj.png" alt="" class='zwsj'>
            <p class='zwsjtxt'>您还没有提交过方案</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 会员档案 -->
    <el-dialog title="会员档案" :visible.sync="danganvisable" @close="closeDialog" :modal-append-to-body="false"
      :close-on-click-modal="false">
      <div class="pinfo">
        <!-- <img class="headicon" src="../../assets/touxiang.jpeg" alt=""> -->
        <p v-if='info.sex==0'>{{info.username}} 未知 {{info.age}}岁</p>
        <p v-if='info.sex==1'>{{info.username}} 男 {{info.age}}岁</p>
        <p v-if='info.sex==2'>{{info.username}} 女 {{info.age}}岁</p>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="医疗档案" name="ylda">
          <el-timeline :reverse="reverse">
            <el-timeline-item v-for="(item, index) in yldaarr" :key="item.id" :timestamp="item.createTime"
              placement="top">
              <el-card>
                <div class="line_box">
                  <p style="width:auto;">标题：{{item.title}}</p>
                  <!-- <el-button class="line_btn" size="mini" type="primary" @click='tochat'>私密问诊</el-button> -->
                  <p>档案类别： {{item.type==0?'纸质':'胶片'}}</p>
                  <p>科室： {{item.departmentName}}</p>
                  <p>档案描述： {{item.detail}}</p>
                  <p>诊断图片： </p>
                  <img v-for='(jtem,index) in item.pictures' :key="index" :src="jtem" mode="" class="zdtp"
                    @click='openimg(jtem)' style='width:200px;float:left' alt="">
                  <img>
                  <p>视频资料：</p>
                  <video v-for="(jtem,index) in item.video" :key="index" :id="'video'+index" :src="jtem"
                    controls="controls" style='width:200px;float:left'></video>
                  <p>其他：</p>
                  <embed v-for="(jtem,index) in item.other" :key="index" :src="jtem" width="800" height="600"></embed>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane label="健康信息表" name="jkxxb">
          <el-form ref="form" :model="form" label-width="80px" class="xxb">
            <el-row>
              <el-col :span="8">
                <el-form-item label="姓名">
                  {{info.username}}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号">
                  {{info.userHealthInfo.mobile}}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="亲属关系">
                  {{info.mainCardUserRel}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="性别">
                  <span v-if='info.sex==0'>未知</span>
                  <span v-if='info.sex==1'>男</span>
                  <span v-if='info.sex==2'>女</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出生日期">
                  {{info.userHealthInfo.birthday}}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身高">
                  {{info.userHealthInfo.height}}cm
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="体重">
                  {{info.userHealthInfo.weight}}kg
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="生命体征">
                  {{info.userHealthInfo.vitalSigns}}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="一般情况">
                  {{info.userHealthInfo.generalSituation}}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-tabs type="border-card" class="bottomtab">
            <el-tab-pane label="基本情况">
              <div class="bt_div">
                <p>头颈部</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="症状:">
                        {{info.proUserBasicSymptoms.headSymptoms}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="辅助检查:">
                        {{info.proUserBasicSymptoms.headAssistExamine}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="就诊历史:">
                        {{info.proUserBasicSymptoms.headSeedoctorHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>胸部</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="症状:">
                        {{info.proUserBasicSymptoms.chestSymptoms}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="辅助检查:">
                        {{info.proUserBasicSymptoms.chestAssistExamin}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="就诊历史:">
                        {{info.proUserBasicSymptoms.chestSeedoctorHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>腹部</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="症状:">
                        {{info.proUserBasicSymptoms.abdomenSymptoms}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="辅助检查:">
                        {{info.proUserBasicSymptoms.abdomenAssistExamin}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="就诊历史:">
                        {{info.proUserBasicSymptoms.abdomenSeedoctorHistorys}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>四肢</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="症状:">
                        {{info.proUserBasicSymptoms.limbsSymptoms}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="辅助检查:">
                        {{info.proUserBasicSymptoms.limbsAssistExamin}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="就诊历史:">
                        {{info.proUserBasicSymptoms.limbsSeedoctorHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>其他</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="症状:">
                        {{info.proUserBasicSymptoms.otherSymptoms}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="辅助检查:">
                        {{info.proUserBasicSymptoms.otherAssistExamine}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="就诊历史:">
                        {{info.proUserBasicSymptoms.otherSeedoctorHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="慢性病史">
              <div class="bt_div">
                <p>高血压(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userChronicMedicalRecords.highbloodHistory}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="最高:">
                        {{info.userChronicMedicalRecords.highbloodHigh}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="服药情况:">
                        {{info.userChronicMedicalRecords.highbloodMedicine}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="目前状况:">
                        {{info.userChronicMedicalRecords.highbloodNow}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>糖尿病(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userChronicMedicalRecords.diabetesHistory}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="餐前最高:">
                        {{info.userChronicMedicalRecords.diabetesBeforemealHigh}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="餐后最高:">
                        {{info.userChronicMedicalRecords.diabetesAftermealHigh}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="服药情况:">
                        {{info.userChronicMedicalRecords.diabetesMedicine}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="目前餐前:">
                        {{info.userChronicMedicalRecords.diabetesBeforemealNow}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="目前餐后:">
                        {{info.userChronicMedicalRecords.diabetesAftermealNow}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>慢性肾衰竭(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userChronicMedicalRecords.crfHistory}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="尿蛋白:">
                        {{info.userChronicMedicalRecords.crfProtein}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="肌酐:">
                        {{info.userChronicMedicalRecords.crfMuscleSolution}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="服药情况:">
                        {{info.userChronicMedicalRecords.crfMedicine}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>冠心病(如有)</p>
                <el-form class="bt_form" label-width="90px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userChronicMedicalRecords.heartdiseaseHistory}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="服药情况:">
                        {{info.userChronicMedicalRecords.heartdiseaseMedicine}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="手术或支架:">
                        {{info.userChronicMedicalRecords.heartdiseaseSurgeryStents}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>其他(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="其他:">
                        {{info.userChronicMedicalRecords.otherSymptoms}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="传染病史">
              <div class="bt_div">
                <p>乙肝(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userInfectiousMedicalRecords.hepatitisBHistory}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="治疗情况:">
                        {{info.userInfectiousMedicalRecords.hepatitisBTreatment}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="目前状况:">
                        {{info.userInfectiousMedicalRecords.hepatitisBSymptoms}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>结核(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userInfectiousMedicalRecords.tuberculosisHistory}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="治疗情况:">
                        {{info.userInfectiousMedicalRecords.tuberculosieTreatment}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="目前状况:">
                        {{info.userInfectiousMedicalRecords.tuberculosiSymptoms}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>伤寒(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userInfectiousMedicalRecords.typhiHistory}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="治疗情况:">
                        {{info.userInfectiousMedicalRecords.typhiTreatment}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="目前状况:">
                        {{info.userInfectiousMedicalRecords.typhiSymptoms}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>疟疾(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userInfectiousMedicalRecords.malariaHistory}}
                      </el-form-item>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="治疗情况:">
                        {{info.userInfectiousMedicalRecords.malariaTreatment}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="目前状况:">
                        {{info.userInfectiousMedicalRecords.malariaSymptoms}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>其他(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="其他:">
                        {{info.userInfectiousMedicalRecords.otherSymptoms}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="其他">
              <div class="bt_div">
                <p>重大手术外伤史(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="情况:">
                        {{info.userOtherInfo.majorSurgicalTraumaHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>输血史(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="情况:">
                        {{info.userOtherInfo.bloodTransfusionHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>过敏史(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="情况:">
                        {{info.userOtherInfo.allergicHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>疫区/疫水接触史(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="情况:">
                        {{info.userOtherInfo.epidemicContactHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>放射/毒物接触史(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="情况:">
                        {{info.userOtherInfo.radiationPoisoningContactHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>吸烟史(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userOtherInfo.smokeHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="每天烟量:">
                        {{info.userOtherInfo.smokeDayNum}}根
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="戒烟多久:">
                        {{info.userOtherInfo.smokeGiveupHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>饮酒史(如有)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="多久:">
                        {{info.userOtherInfo.drinkHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="每天酒量:">
                        {{info.userOtherInfo.drinkDayNum}}两
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="戒酒多久:">
                        {{info.userOtherInfo.drinkGiveupHistory}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>月经婚育史(男性)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="是否已婚:">
                        <span v-if='info.userOtherInfo.manMarriage==0'>未婚</span>
                        <span v-if='info.userOtherInfo.manMarriage==1'>已婚</span>
                        <span v-if='info.userOtherInfo.manMarriage==2'>离异</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="子女有无:">
                        <span v-if='info.userOtherInfo.manChild==0'>没有</span>
                        <span v-if='info.userOtherInfo.manChild==1'>有</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="妻子体健:">
                        <span v-if='info.userOtherInfo.manWifeHealth==0'>不健康</span>
                        <span v-if='info.userOtherInfo.manWifeHealth==1'>健康</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="儿子:">
                        {{info.userOtherInfo.manSon}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="女儿:">
                        {{info.userOtherInfo.manGirl}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>月经婚育史(女性)</p>
                <el-form class="bt_form" label-width="80px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="初潮年龄:">
                        {{info.userOtherInfo.womanMenarcheAge}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="月经周期:">
                        {{info.userOtherInfo.womanMenstrualCycle}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="月经持续:">
                        {{info.userOtherInfo.womanMenstrualContinued}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="LMP:">
                        {{info.userOtherInfo.womanLmp}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="是否已婚:">
                        <span v-if='info.userOtherInfo.womanMarriage==0'>未婚</span>
                        <span v-if='info.userOtherInfo.womanMarriage==1'>已婚</span>
                        <span v-if='info.userOtherInfo.womanMarriage==2'>离异</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="子女有无:">
                        <span v-if='info.userOtherInfo.womanChild==0'>没有</span>
                        <span v-if='info.userOtherInfo.womanChild==1'>有</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="丈夫体健:">
                        <span v-if='info.userOtherInfo.womanHusbandHealth==0'>不健康</span>
                        <span v-if='info.userOtherInfo.womanHusbandHealth==1'>健康</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="儿子:">
                        {{info.userOtherInfo.womanSon}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="女儿:">
                        {{info.userOtherInfo.womanGirl}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="bt_div">
                <p>家族病史(如有)</p>
                <p class='smtitle'>慢性病史(如有)</p>
                <el-form class="bt_form" label-width="90px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="高血压:">
                        {{info.userOtherInfo.chronichisHighblood}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="慢性肾衰竭:">
                        {{info.userOtherInfo.chronichisCrf}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="冠心病:">
                        {{info.userOtherInfo.chronichisHeartdisease}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="糖尿病:">
                        {{info.userOtherInfo.chronichisDiabetes}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="其他慢性病:">
                        {{info.userOtherInfo.chronichisOthers}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <p class='smtitle'>肝病及其他遗传病史(如有)</p>
                <el-form class="bt_form" label-width="90px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="肝病病史:">
                        {{info.userOtherInfo.liver}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="其他遗传病:">
                        {{info.userOtherInfo.other}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>
    <!-- 方案1 -->
    <el-dialog title="编辑方案" :visible.sync="fanganvisable" class="fangandia" @close="closefaDialog"
      :modal-append-to-body="false">
      <!-- <p>于2019-11-19 13:00:00提交</p> -->
      <el-form ref="form" :model="form" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="患者姓名:">
              {{form.patientName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属小组:">
              {{form.groupName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="方案标题:">
              <el-input v-model="form.title" placeholder='请输入方案标题'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="总结:">
              <el-input v-model="form.conclusion" placeholder='请输入总结'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="具体方案:">
              <el-input v-model="form.plan" type="textarea" placeholder='请输入具体方案'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="提交时间:">
              {{form.updateTime}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="add-btn" type="primary" @click="editPlan(0)">确 定
        </el-button>
        <el-button @click="closefaDialog">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="预览" :visible.sync="imgvisable" class="fangandia" @close="closeimgDialog"
      :modal-append-to-body="false">
      <img :src="showimgurl" alt="" style="width:98%;margin:1%">
    </el-dialog>
  </div>
</template>

<script>
  import Vue from "vue";
  import MessageBox from "../../components/chat/index.vue";
  import Message from "../../components/chat/message.vue";
  import AddFriend from "../../components/addModal/addFriend.vue";
  import GetFriendRequest from "../../components/addModal/getFriendRequest.vue";
  import FirendBlack from "../../components/addModal/firendBlack.vue";
  import AddGroupUser from "../../components/group/addGroupUser.vue";
  import CreateGroup from "../../components/group/createGroup.vue";
  import VidoeSetting from "../../components/videoSetting/index";
  import GroupRequest from "../../components/group/groupRequest.vue";
  import GroupInvite from "../../components/group/groupInvite.vue";
  import "./index.less";
  import axios from 'axios';
  import {
    getMyGroups,
    getConsultationGroups,
    getConsultationPorUserInfo,
    getMyPlans,
    editPlan,
    delPlan,
    getuserInfo,
    userCaseReportList,
    searchMemberRecord,
    getGroupCount,
    clearSingleHzGroupCount,
    clearSingleYsGroupCount,
    clearSingleSmGroupCount
  } from "../../api/getData";

  import {
    mapState,
    mapActions
  } from "vuex";
  export default {
    inject: ['reload'],
    data() {
      return {
        showimgurl: '',
        imgvisable: false,
        normelWidth: '78%',
        fanganvisable: false,
        groupRead: false,
        contactRead: false,
        showSettingOptions: false,
        activeKey: "contact",
        selectedItem: "",
        showAddOptions: false,
        addList: [{
            name: "添加好友",
            id: "1",
            icon: "chat"
          },
          {
            name: "申请入群",
            id: "2",
            icon: "friends"
          },
          {
            name: "创建群组",
            id: "3",
            icon: "comment"
          }
        ],
        userName: localStorage.getItem("userInfo") &&
          JSON.parse(localStorage.getItem("userInfo")).userId,
        collapsed: false,
        broken: false,
        current: ["contact"],
        groupList: [],
        danganvisable: false,
        activeName: 'ylda',
        reverse: true,
        activities: [],
        form: {},
        bruserinfo: {
          realName: ''
        },
        myplan: [],
        groupId: '',
        userId: '',
        yldaarr: [],
        info: {
          proUserBasicSymptoms: {},
          userChronicMedicalRecords: {},
          userHealthInfo: {},
          userInfectiousMedicalRecords: {},
          userOtherInfo: {}
        },
        chooseindex: ''
      };
    },

    created() {
      this.groupList = [];
      this.getMyGroups();
      console.log(this.bruserinfo.realName)
      this.topindex = localStorage.index
      if (this.topindex != 3) {
        this.normelWidth = '78%'
      } else {
        this.normelWidth = '93%'
      }
    },
    mounted() {
      // this.login();
      this.getuserInfo();

    },
    computed: {
      chatList() {
        return this.$store.state.chat.msgList;
      }
    },
    methods: {
      closeimgDialog(){
        this.imgvisable=false
      },
      openimg(jtem) {
        this.showimgurl = jtem
      },
      tochat() {
        this.$router.push("/contact/" + this.info.imId);
        this.reload();
      },
      ...mapActions(["onLogin", "setRegisterFlag", "onRegister"]),
      // 获取用户信息
      async getuserInfo() {
        var res = await getuserInfo();
        if (res.code == "0") {
          // this.toLogin(res.data.imId, 123)
          console.log('11qweqe')
          // this.toLogin(res.data.imId, res.data.imPassword)
        } else {

        }
      },
      toLogin(username, password) {
        this.onLogin({
          username: username.toLowerCase(),
          password: password
        });

      },
      fatherMethod() {
        this.getMyPlans(this.groupId, this.userId)
      },
      // 删除方案
      async delPlan(id) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async _ => {
          var res = await delPlan({
            id: id
          });
          if (res.code == "0") {
            this.$message({
              type: "success",
              message: '删除成功'
            });
            this.getMyPlans(this.groupId, this.userId)
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        })
      },
      // 编辑方案
      async editPlan(type) {
        let subform = {};
        if (this.form.title == '') {
          this.$message({
            type: "error",
            message: '请输入方案标题'
          });
        } else if (this.form.conclusion == '') {
          this.$message({
            type: "error",
            message: '请输入总结'
          });
        } else if (this.form.plan == '') {
          this.$message({
            type: "error",
            message: '请输入方案'
          });
        } else {
          subform.id = this.form.id;
          subform.conclusion = this.form.conclusion;
          subform.plan = this.form.plan;
          subform.title = this.form.title;
          subform.submitType = type
          var res = await editPlan(subform);
          if (res.code == "0") {
            this.$message({
              type: "success",
              message: '编辑成功'
            });
            this.closefaDialog();
            this.getMyPlans(this.groupId, this.userId)
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        }




      },
      handelEdit(row) {
        if (row.type == 1) {
          this.getPlanInfo(row.id);
        } else {
          let txt = JSON.stringify(row);
          this.form = JSON.parse(txt);
          this.fanganvisable = true;
        }

      },
      closefaDialog() {
        this.fanganvisable = false
      },
      // 获取我提交的方案    
      async getMyPlans(groupId, userId) {
        var res = await getMyPlans({
          imGroupId: groupId,
          userId: userId
        });
        if (res.code == "0") {
          this.myplan = res.data
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },

      // 清除单个会诊小组的未读消息    
      async clearSingleHzGroupCount(id) {
        console.log(id)
        var res = await clearSingleHzGroupCount({
          groupId: window.sessionStorage["groupId"],
          imGroupId: id
        });
        if (res.code == "0") {


        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      // 清除单个医生小组的未读消息    
      async clearSingleYsGroupCount(id) {
        var res = await clearSingleYsGroupCount({
          groupId: window.sessionStorage["groupId"],
          imGroupId: id
        });
        if (res.code == "0") {

        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      // 清除单个私密问诊的未读消息    
      async clearSingleSmGroupCount(id) {
        var res = await clearSingleSmGroupCount({
          groupId: window.sessionStorage["groupId"],
          imId: id
        });
        if (res.code == "0") {

        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },

      // 获取某个会诊小组的用户信息    
      async getConsultationPorUserInfo(id) {
        console.log(id)
        var res = await getConsultationPorUserInfo({
          imGroupId: id
        });
        if (res.code == "0") {
          this.bruserinfo = res.data[0];
          this.bruserinfo.groupId = id
          this.groupId = id;
          this.userId = res.data[0].userId
          this.getMyPlans(id, res.data[0].userId)
          this.userCaseReportList(res.data[0].userId);
          this.searchMemberRecord(res.data[0].userId)
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },

      // 条件查询病例报告列表    
      async userCaseReportList(id) {
        var res = await userCaseReportList({
          userId: id,
          page: 1,
          rows: 9999
        });
        if (res.code == "0") {
          this.yldaarr = res.data.caseReportInfo.list;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      // 查询会员档案
      async searchMemberRecord(id) {
        var res = await searchMemberRecord({
          userId: id,
        });
        if (res.code == "0") {
          this.info = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },

      // 获取某个小组的会诊小组    
      getConsultationGroups(id) {
        window.sessionStorage["groupId"] = id


        this.$data.collapsed = false;
        this.$refs.messageBox.onGetGroupUserList();
      },

      // 获取我所属的一级小组    
      async getMyGroups() {
        var res = await getMyGroups();
        if (res.code == "0") {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].isChecked = false;
            this.getGroupCount(i, res.data[i].id)
          }
          this.groupList = res.data;
          this.chooseGroup(0)
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      async getMyGroups1() {
        var res = await getMyGroups();
        if (res.code == "0") {
          for (let i = 0; i < res.data.length; i++) {
            this.getGroupCount(i, res.data[i].id)
          }
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      // 获取某个小组所有IM小组的未读消息总    
      async getGroupCount(i, id) {
        var res = await getGroupCount({
          groupId: id
        });
        if (res.code == "0") {
          this.groupList[i].wdxx = res.data;
          let txt = JSON.stringify(this.groupList);
          this.groupList = JSON.parse(txt);
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },

      // 关闭会员档案弹窗
      closeDialog() {
        this.danganvisable = false;
      },
      // 选择小组
      chooseGroup(index) {
        this.chooseindex = index
        for (let i = 0; i < this.groupList.length; i++) {
          this.groupList[i].isChecked = false;
        }
        this.groupList[index].isChecked = true;

        if (localStorage.index == 2) {
          this.activeKey = 'contact'
          this.$data.activeKey = 'contact';
          this.getConsultationGroups(this.groupList[index].id);
        }
        if (localStorage.index == 3) {
          this.activeKey = 'group'
          this.$data.activeKey = 'group';
          this.getConsultationGroups(this.groupList[index].id);
        }
        if (localStorage.index == 4) {
          this.activeKey = 'group'
          this.$data.activeKey = 'group';
          this.getConsultationGroups(this.groupList[index].id);
        }

      },

      ...mapActions(["onLogout", "onGetFirendBlack"]),
      toLogout() {
        this.onLogout();
      },
      onCollapse(collapsed, type) {
        if (type != "responsive") {
          this.$data.collapsed = true;
        } else {
          this.$data.collapsed = false;
        }
      },
      onBreakpoint(broken) {
        this.$data.broken = broken;
      },
      hideUserList() {
        this.$data.collapsed = true;
      },
      showUserList() {
        this.$data.collapsed = false;
      },
      select(i) {
        if (localStorage.index == 4) {
          this.getConsultationPorUserInfo(i.groupid);
          this.clearSingleHzGroupCount(i.groupid);
          this.getConsultationGroups(this.groupList[this.chooseindex].id);
          this.getMyGroups1()
        }
        if (localStorage.index == 2) {
          this.bruserinfo = i;
          console.log(this.bruserinfo)
          this.clearSingleSmGroupCount(i.imId);
             this.getMyPlans(this.groupId, this.userId)
          this.getConsultationGroups(this.groupList[this.chooseindex].id);
          this.getMyGroups1()
        }
        if (localStorage.index == 3) {
          this.clearSingleYsGroupCount(i.groupid);
          this.getConsultationGroups(this.groupList[this.chooseindex].id);
        }
        this.$refs.messageList.select(i);
        if (this.broken) {
          this.$data.collapsed = true;
        }
      },
      GetFirendBlack() {
        this.onGetFirendBlack();
        this.$refs.firendModel.changModel();
      },
      optionsVisibleChange() {
        this.$data.showSettingOptions = !this.$data.showSettingOptions;
      },
      contactTypeChange(type) {
        this.$data.activeKey = type.key;
        this.$router.push(`/${type.key}`);
        if (this.broken && this.collapsed) {
          this.$data.collapsed = false;
        }

        switch (type.key) {
          case "contact":
            this.$refs.messageBox.onGetContactUserList();
            break;
          case "group":
            this.$refs.messageBox.onGetGroupUserList();
            break;
          case "chatroom":
            this.$refs.messageBox.onGetChatroomUserList();
            break;
          default:
            break;
        }
        this.$refs.messageList.getCurrentMsg(type.key);
      },
      addModalChange() {
        this.$data.showAddOptions = !this.$data.showAddOptions;
      },
      ulClick(i) {
        // this.addModalChange();
        switch (i) {
          case "1":
            this.$refs.addFriendMethods.changeModal();
            break;
          case "2":
            this.$refs.addGroupModel.changeGroupModel();
            break;
          case "3":
            this.$refs.createGroupModel.changeCreateModel();
            break;
          default:
            break;
        }
      },
      recEmedia() {
        this.$refs.videoSetting.show();
      },
      getUnread(type) {
        const chatList = this.chatList[type];
        let obj = {
          contact: false,
          group: false
        };
        if (JSON.stringify(chatList) != "{}") {
          for (const item in chatList) {
            chatList[item].map((v, k) => {
              if (v.status === "unread") {
                if (v.chatType === "group") {
                  obj.group = true;
                }
                if (v.chatType === "contact") {
                  obj.contact = true;
                }
              }
              return obj;
            });
          }
        }
        return {
          contact: obj.contact,
          group: obj.group
        };
      }
    },
    components: {
      MessageBox,
      Message,
      AddFriend,
      GetFriendRequest,
      FirendBlack,
      AddGroupUser,
      CreateGroup,
      VidoeSetting,
      GroupRequest,
      GroupInvite
    },
    watch: {
      $route(to, from) {

        console.log(to, from)
        if (to.path == 'contact/hz' || to.path.indexOf('group') > -1) {
          this.getuserInfo();
        } else {
          this.chooseGroup(0)
        }

      }
    },
  };

</script>
<style lang="less">
  .main {
    width: 100%;
    height: 100%;
    background-color: #f0f2f5;
    float: left;

    .el-form-item__label {
      font-weight: 800;
    }

    .infobox {
      width: 83%;
      float: left;
      height: 95%;
      margin: 1%;
    }

    .middlechat {
      width: 99%;
      margin: 1% 0 1% 1%;
      float: left;
      background-color: #fff;
      height: 97%;
    }

    .ant-layout-content {
      background-color: #fff;
    }

    .left {
      width: 20%;
      float: left;
      height: 100%;
      // border-right: 1px solid #e8e8e8;
      border-top: 1px solid #999;
      background-color: #001529;
      overflow-y: auto;

      p {
        width: 100%;
        padding: 5%;
        float: left;
        text-align: left;
        cursor: pointer;
        font-size: 16px;
        color: #fff;

        .wdxx {
          background-color: red;
          color: #fff;
          width: 20px;
          border-radius: 20px;
          line-height: 20px;
          text-align: center;
          float: right;
          font-weight: 900;
        }
      }

      .check {
        background-color: #002140;
        color: #fff;
        font-size: 16px;
        font-weight: 900;
      }
    }

    .middle {
      width: 65%;
      height: 100%;
      float: left;
      background-color: rgba(240, 242, 245, 1);
    }

    .right {
      width: 20%;
      height: 100%;
      float: left;
      border-left: 1px solid #e8e8e8;
      position: relative;
      background-color: #fff;

      .myplan {
        width: 90%;
        float: left;
        margin-left: 5%;
        margin-top: 100px;
        position: absolute;
        bottom: 20px;

        .plantitle {
          width: 100%;
          float: left;
          text-align: left;
          font-size: 20px;
          margin-bottom: 0;
        }

        .planbox {
          width: 100%;
          height: 300px;
          overflow-y: auto;
          float: left;

          .planLists {
            width: 100%;
            float: left;

            .delete {
              width: 34px;
              height: 18px;
              border-radius: 2px;
              border: 1px solid #1890FF;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #1890FF;
              line-height: 18px;
              text-align: center;
            }

            .edit {
              width: 34px;
              height: 18px;
              border-radius: 2px;
              border: 1px solid rgba(153, 153, 153, 1);

              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 18px;
              text-align: center;
            }

            p {
              width: 100%;
              float: left;
              margin: 20px 0;
              text-align: left;
              margin-bottom: 0;

              span {
                color: #777777
              }
            }

            a {
              float: right;
              margin-left: 10px;
            }
          }
        }
      }

      .headicon {
        width: 102px;
        height: 102px;
        margin: 0 auto;
        border-radius: 100%;
        margin-top: 10%
      }

      .nameinfo {
        width: 100%;
        text-align: center;
        line-height: 40px;
        font-size: 25px;
        margin-bottom: 0;
        font-weight: 900;
        margin: 10px 0;
      }

      .right_btn {
        width: 70%;
        border: 1px solid #409eff;
        color: #409eff;
        margin-top: 10%
      }


    }

    .pinfo {
      width: 100%;
      height: auto;
      text-align: left;

      .headicon {
        height: 70px;
        float: left;
        border-radius: 100%;
      }

      p {
        display: inline-block;
        font-size: 20px;
        line-height: 30px;
        font-weight: 600;
        width: 100%;
        text-align: center
      }
    }

    .el-tabs__nav {
      width: 100%
    }

    .el-tabs__item {
      width: 50%;
    }

    .bottomtab {
      .el-tabs__item {
        width: 25%;
      }
    }

    .el-timeline-item__wrapper {
      text-align: left
    }

    .line_box {
      width: 100%;
      float: left;

      p {
        float: left;
        width: 100%;
        line-height: 30px;
        margin-bottom: 0;
      }
    }

    .line_btn {
      float: left;
      margin-left: 15px;
    }

    .el-card {
      -webkit-box-shadow: none;
      box-shadow: none;
      border: none;
      width: 95%
    }

    .el-card__body {
      padding: 0px;
    }

    .el-form {
      width: 50%;
      margin-left: 25%
    }

    .el-row {
      margin-bottom: 0
    }

    .el-form-item {
      margin-bottom: 0
    }

    .el-form-item__content {
      text-align: left;
    }

    .el-dialog {
      // width: 40%;
      // height: 700px;
      overflow-y: auto
    }

    .el-tabs--border-card>.el-tabs__header {
      float: left;
      width: 100%
    }

    .el-tabs__content {
      overflow-y: auto;
      height: 450px;
    }

    .bottomtab .el-tabs__content {

      height: auto !important;
    }

    .bt_div {
      width: 100%;
      float: left;

      p {
        float: left;
        margin-bottom: 0;
        font-size: 20px;
        font-weight: 800
      }
    }

    .bt_form {
      width: 100%;
      float: left;
      margin-left: 0;
    }

    .el-tabs__item:first-child {
      border-left: none
    }

    .smtitle {
      width: 100%;
      float: left !important;
      font-size: 16px !important;
      font-weight: normal !important;
      text-align: left;
      margin: 10px 0;
    }

    .fangandia {
      .el-dialog {
        width: 500px !important;

        // height: 400px;
        .el-dialog__body {
          padding-bottom: 0
        }
      }

      .el-form {
        width: 100%;
        margin-left: 0;
      }
    }

    .fangandia {
      .el-form-item {
        margin-bottom: 10px;
      }
    }

    .xxb {
      width: 100%;
      float: left;
      margin: 0;
      margin-top: 50px;
    }

    .zwsj {
      width: 88px;
      margin: 0 auto;
      margin-top: 60px;
    }

    .zwsjtxt {
      width: 100%;
      text-align: center;
      margin-top: 20px;
      color: #AAAAAA
    }

    .infotop {
      width: 100%;
      float: left;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/chat/index.vue